import React from "react";
import axios from "axios";
import LoadingInput from "../../../_components/LoadingInput";
import Text from "../../../_components/Text";
import IconButton from "../../../_components/IconButton";
import styled, { css } from "styled-components";
import * as colors from "../../../assets/_base/colors";


const Button = styled.button`
    border: none;
    font-family: Titillium Web;
    cursor: pointer;
    border-radius: 10px;
    background-color: #84bbf3;
    color: white;

    font-weight: 900;

    :hover {
        background-color: ${colors.lightBlue};
    }
    :disabled{
        background-color: #bdced5;
        color: #f1f3f4;
        cursor: not-allowed;
    }
    :active {
        background-color: #0572b5;
        color: #3bbdff;
    }
`

const Input = styled(LoadingInput)`
  border-radius: 10px;
  min-width: 100% !important;
`;
const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  input {
  }
`;


const CardTitle = styled(Text)`
  color: ${colors.dark};
  text-align: center;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;


export default (props) => {
  const [search, setQuery] = React.useState("");
  const [result, setResult] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  
  const trackedArticles = [
    { title: 'COMPROVAR RENDA COMO MEI, Perguntas e RESPOSTAS Mais Frequentes', url: 'https://bit.ly/46dncQE' },
    { title: 'Como Emitir Cupom Fiscal no Emissor Gratuito do Easygestor | Fácil e Rápido', url: 'https://bit.ly/474HOvp' },
    { title: 'XML da Nota Fiscal | O que é E como Usar', url: 'https://bit.ly/40sNfSq' },
    { title: 'Como consultar notas fiscais? Aprenda agora com esse PASSO A PASSO (NF-e)', url: 'https://bit.ly/3sgyp53' },
    { title: 'Eu Preciso de Certificado Digital? [PERGUNTAS e RESPOSTAS]', url: 'https://bit.ly/465VsNq' },
    { title: 'MEI Como Trocar as Informações e seu Cadastro Grátis (Atualizar Dados)', url: 'https://bit.ly/3SBolOz' },
    { title: 'Como Se Credenciar para EMITIR NOTA FISCAL ELETRÔNICA | MEI e ME e EPP na SEFAZ de SÃO PAULO', url: 'https://bit.ly/47svCod' },
    { title: 'Como Obter Certificado Digital para EMITIR NOTA FISCAL, para Advogados, Contadores e Pessoa Física.', url: 'https://bit.ly/3MBuFBY' },
    { title: 'Como Emitir Nota Fiscal Eletrônica pelo CELULAR | Alternativa ao Emissor Gratuito SEBRAE - MEI e EPP', url: 'https://bit.ly/3Qtkoc7' },
    { title: 'Tudo sobre Inscrição Estadual | O que é e como Tirar a Sua', url: 'https://bit.ly/49pz58K' },
    { title: 'Como Código de Barras Funcionam: Tudo o que Você Precisa Saber', url: 'https://bit.ly/3SDeKXL' },
    { title: 'Entenda o Projeto Easygestor', url: 'https://bit.ly/3QQM1NO' },
    { title: 'Como Emitir Nota Fiscal MEI no EMISSOR GRATUITO do Easygestor Online | ALTERNATIVA ao do SEBRAE ', url: 'https://bit.ly/3SxBUyn' },
    { title: 'MEI: Como gerar a DISPENSA do ALVARÁ de FUNCIONAMENTO | PASSO A PASSO OFICIAL Facilitado', url: 'https://bit.ly/3u9dxgA' },
    { title: 'Como Fazer Nota Fiscal Eletrônica de Devolução | Emissor Gratuito do Easygestor', url: 'https://bit.ly/3QypQut' }
  ]

  function onSearch() {
    const params = {
      per_page: 10,
      search,
    };
    setLoading(true);
    setResult([]);
    const url = `https://otimizeseunegocio.com/wp-json/wp/v2/search`;
    axios
      .get(url, { params })
      .then((resp) => {
        setResult(resp.data);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }

  function init() {
    onSearch()
  }

  React.useEffect(init, [])

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Text color="primary" className="text-center my-3 h5">
            Pesquisar conteúdo no portal Otimize seu Negócio
          </Text>
        </div>
        <div className="col-md-6 mx-auto">
          <Box>
            <Input
              loading={loading}
              onKeyPress={e => {
                if (e.key === 'Enter')
                  onSearch()
              }}
              onChange={(e) => setQuery(e.target.value)}
            />
            <IconButton
              disabled={loading}
              className="ml-1"
              icon="search"
              onClick={onSearch}
            />
          </Box>
        </div>
      </div>
      <div className="row">
        {result.map((result, idx) => {
          return (
            <div
              className="col-md-4 col-xs-12 mb-5 text-center"
              key={`help-otimizeseunegocio-result-query-${result.url}-${idx}`}
            >
              <i
                className='fas fa-question-circle'
                style={{
                  color: '#84bbf3',
                  fontSize: 30,
                  position: 'absolute',
                  left: 0,
                  top: -10
                }}
              />
              <div style={{
                backgroundColor: 'white',
                padding: '10px',
                borderRadius: 40,
                borderTopLeftRadius: 0,
                borderBottomRightRadius: 0,
                boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.2)',
                paddingTop: 10
              }}>
                <CardTitle
                  color="primary"
                  className="pt-2"
                  style={{
                    height: 60,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {result.title}
                </CardTitle>
                <CardFooter>
                  <Button
                    onClick={() => window.open(result.title.includes(trackedArticles[idx] && trackedArticles[idx].title) ? trackedArticles[idx].url : result.url)}
                    className='btn btn-sm'
                  >
                    Ver mais
                  </Button>
                </CardFooter>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Help/index.jsx